
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CampaignFollowItem } from '@/types/campaigns'
import SpotifyItemSelector from '@/components/common/SpotifyItemSelector.vue'
import ItemList from '@/components/common/ItemList.vue'

@Component({
  components: { SpotifyItemSelector, ItemList }
})
export default class StreamingFollow extends Vue {
  @Prop({ required: true, type: Array }) value!: CampaignFollowItem[]

  get items () {
    return this.value
  }

  set items (value: CampaignFollowItem[]) {
    this.$emit('input', value)
  }

  updateItems (updatedItems: CampaignFollowItem[]) {
    this.$emit('input', updatedItems)
  }

  addItem (item: CampaignFollowItem) {
    const newValue = [...this.value, item]
    this.$emit('input', newValue)
  }
}
